export const navbarColor = process.env.NAVBAR_COLOR ?? "dark";
